/*
* This file is auto-generated by "code-gen/generate-brand-index.ts". Do not modify it.
* Look at the script in package.json for how to update it.
*/
import df18Brunello from './df18Brunello';

const brands = {
	'df18Brunello': df18Brunello,
};

export default brands;



// WEBPACK FOOTER //
// ./src/brands/index.ts